import { useState, useEffect } from "react";
import { NotificationServices } from "../services/NotificationServices";
import CrossIcon from "../assets/crossIcon.svg";
import { handleApiErrorResponses } from "../utils/ApisErrorHandling";
import { CircularProgress } from "@mui/material";

const EditStageInfo = ({ selectedStage, setOpen, getCaseStageData }) => {
  const [saving, setSaving] = useState(false);
  const [isChanged, setIsChanged] = useState(false);
  const [ccStageText, setCcStageText] = useState(
    selectedStage?.commandCenterStageText
  );
  const [hsaMobileText, setHsaMobileText] = useState(
    selectedStage?.hsaStageMobileText
  );
  const [hsaWebText, setHsaWebText] = useState(selectedStage?.hsaStageWebText);

  const updateStageData = async () => {
    setSaving(true);
    try {
      const data = [
        {
          id: selectedStage.id,
          commandCenterStageText: ccStageText,
          hsaStageMobileText: hsaMobileText,
          hsaStageWebText: hsaWebText,
        },
      ];
      const response = await NotificationServices.addOrEditDefaultStages(data);
      window.alert(response?.data?.message);
      await getCaseStageData();
      setOpen(null);
    } catch (error) {
      handleApiErrorResponses(error);
    }
    setSaving(false);
  };
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      return (document.body.style.overflow = "auto");
    };
  }, []);
  return (
    <div className="fixed h-screen w-screen top-0 left-0 flex justify-center items-center bg-[#017C5780] z-[1201]">
      <div className="relative w-[70%] h-fit bg-white px-10 py-5 rounded-[20px]">
        <div className="absolute right-8 top-5 cursor-pointer ">
          <img
            src={CrossIcon}
            alt="close-popup-icon"
            onClick={() => setOpen(null)}
          />
        </div>
        <div className="h-fit flex flex-wrap justify-between  items-center  space-y-5  mt-4 px-4 overflow-y-auto">
          <div className="w-[48%]">
            <div>CC Stage Status</div>
            <input
              type="text"
              disabled
              style={{ border: "1px solid #E4E4E4" }}
              className="w-full outline-none p-2 rounded-[8px] mt-2"
              defaultValue={selectedStage?.commandCenterStageStatus}
            />
          </div>
          <div className="w-[48%]">
            <div>CC Stage Text</div>
            <input
              type="text"
              style={{ border: "1px solid #E4E4E4" }}
              className="w-full outline-none p-2 rounded-[8px] mt-2"
              placeholder="Enter Command Center Stage Text"
              onChange={(e) => {
                setCcStageText(e.target.value);
                setIsChanged(true);
              }}
              defaultValue={ccStageText}
            />
          </div>
          <div className="w-[48%]">
            <div>HSA Mobile Status</div>
            <input
              type="text"
              disabled
              style={{ border: "1px solid #E4E4E4" }}
              className="w-full outline-none p-2 rounded-[8px] mt-2"
              placeholder="Enter Phone Number"
              defaultValue={selectedStage?.hsaMobileStatus}
            />
          </div>
          <div className="w-[48%]">
            <div>HSA Mobile Text</div>
            <input
              type="text"
              style={{ border: "1px solid #E4E4E4" }}
              className="w-full outline-none p-2 rounded-[8px] mt-2"
              placeholder="Enter Phone Number"
              onChange={(e) => {
                setHsaMobileText(e.target.value);
                setIsChanged(true);
              }}
              value={hsaMobileText}
            />
          </div>
          <div className="w-[48%]">
            <div>HSA Web Status</div>
            <input
              type="text"
              disabled
              style={{ border: "1px solid #E4E4E4" }}
              className="w-full outline-none p-2 rounded-[8px] mt-2"
              placeholder="Enter Phone Number"
              defaultValue={selectedStage?.hsaWebStatus}
            />
          </div>
          <div className="w-[48%]">
            <div>HSA Web Text</div>
            <input
              type="text"
              style={{ border: "1px solid #E4E4E4" }}
              className="w-full outline-none p-2 rounded-[8px] mt-2"
              placeholder="Enter Phone Number"
              onChange={(e) => {
                setHsaWebText(e.target.value);
                setIsChanged(true);
              }}
              value={hsaWebText}
            />
          </div>
        </div>
        <div className="flex justify-center mt-5">
          {saving ? (
            <CircularProgress />
          ) : (
            <div
              className="w-fit text-sm font-semibold text-white bg-[#017C57] px-10 py-3 rounded-full cursor-pointer"
              onClick={() => isChanged && updateStageData()}
            >
              SUBMIT
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default EditStageInfo;
